import * as React from 'react'
import { useUsage } from './useUsage'
import { useSnackbar } from '../Snackbar'
import { LAST_FREE_GRAPH_HINT } from './paywallCopy'
import { useBootstrapStore } from '../../stores/useBootstrapStore'
import { isOnGraphRoute } from '../../stores/bootstrap/urlHelpers'

const STORAGE_KEY = 'paywall-last-free-hint'

// Once the third free graph exists, one non-blocking hint on the graph
// page. Nothing blocks; the numbers live on the usage chip in the graph list.
export default function LastFreeGraphHint() {
    const { usage, isFree } = useUsage()
    const bootState = useBootstrapStore(state => state.bootState)
    const username = useBootstrapStore(state => state.user?.username)
    const showSnackbar = useSnackbar(state => state.showSnackbar)

    React.useEffect(() => {
        if (bootState !== 'ready' || !isFree || !usage || !isOnGraphRoute())
            return
        const graphs = usage.graphsCreated
        if (typeof graphs?.limit !== 'number' || graphs.used < graphs.limit)
            return
        try {
            if (window.sessionStorage.getItem(STORAGE_KEY) === username) return
            window.sessionStorage.setItem(STORAGE_KEY, username)
        } catch (error) {
            // sessionStorage unavailable (private mode): show it every time.
        }
        showSnackbar('info', LAST_FREE_GRAPH_HINT, 'top', 8000)
    }, [bootState, isFree, usage, username, showSnackbar])

    return null
}
